import { QUOTE_SCOPE } from "@msys/textutils";
import { AvailableReplacementsModal } from "../../documents/AvailableReplacementsModal.js";

interface Props {
  handleClose(): void;
}

export function QuoteTextsAvailableReplacementsModal({ handleClose }: Props) {
  return (
    <AvailableReplacementsModal scope={QUOTE_SCOPE} handleClose={handleClose} />
  );
}
